/**
 * tournamentCard.tsx
 * 
 * @copyright jnakaso.com
 * 
 * render scores for a tournament
 * 
 */
import { Box, Card, Center, ScrollArea, Table, Tabs, TabsList, TabsPanel, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { tournamentService } from "src/services/tournamentService";

function FlightTable(props: { scores: any[] }) {
    const [rows, setRows] = useState<any[]>([])

    useEffect(() => {
        if (props.scores) {
            setRows(props.scores.map((s: any, idx) =>
                <Table.Tr key={idx}>
                    <Table.Td><Text fw={600} >{s.playerName}</Text></Table.Td>
                    <Table.Td>{s.handicap}</Table.Td>
                    {s.total > 0 &&
                        <>
                            <Table.Td>{s.total}</Table.Td>
                            <Table.Td bg={'var(--mantine-color-blue-light)'}>{s.totalNet}</Table.Td>
                            <Table.Td>{s.front === 0 ? '' : s.front}</Table.Td>
                            <Table.Td>{s.front === 0 ? '' : s.frontNet}</Table.Td>
                            <Table.Td>{s.back === 0 ? '' : s.back}</Table.Td>
                            <Table.Td>{s.back === 0 ? '' : s.backNet}</Table.Td>
                        </>
                    }
                    {s.total === 0 && <>
                        <Table.Td colSpan={7}>{"DNF"}</Table.Td>
                    </>}
                </Table.Tr>
            ))
        }
    }, [props])

    return <ScrollArea style={{ overflowY: "auto" }}>
        <Table>
            <Table.Thead>
                <Table.Tr>
                    <Table.Th w={200}>Player</Table.Th>
                    <Table.Th w={150}>HDCP</Table.Th>
                    <Table.Th w={150}>TOT</Table.Th>
                    <Table.Th w={150} bg={'var(--mantine-color-blue-light)'}>TOT Net</Table.Th>
                    <Table.Th w={150}>FRT</Table.Th>
                    <Table.Th w={150}>FRT Net</Table.Th>
                    <Table.Th w={150}>BCK</Table.Th>
                    <Table.Th w={150}>Bck Net</Table.Th>
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    </ScrollArea>
}

function TournamentCard(props: { tournament: any, title?: string }) {
    const [activeTab, setActiveTab] = useState<string>("A");
    const [flights, setFlights] = useState<string[]>([]);

    useEffect(() => {
        if (props.tournament) {
            const flts = props.tournament.flights
                ? props.tournament.flights.map((f: any) => f.name)
                : Array.from(new Set(props.tournament.rounds.map(r => r.flight)));
            setFlights(flts);
            setActiveTab(flts[0]);
        }
    }, [props])

    if (!props.tournament) {
        return <Card>
            No tournament listed.
        </Card>
    }

    return (props.tournament &&
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
                <Center h={80} bg="var(--mantine-color-gray-light)">
                    <Text fw={800} > {props.title} {props.tournament.course} {props.tournament.date} </Text>
                </Center>
            </Card.Section>
            <Tabs value={activeTab} onChange={(val) => setActiveTab(val!)}  >
                <TabsList>
                    {flights.map(f =>
                        <Tabs.Tab value={f} key={f}>
                            <Text fw={800} >{f}</Text>
                        </Tabs.Tab>
                    )}
                    {props.tournament.team &&
                        <Tabs.Tab value={'team'} key={'team'}>
                            <Text fw={800} >Team</Text>
                        </Tabs.Tab>
                    }
                </TabsList>
                {flights.map((f, idx) =>
                    <TabsPanel key={idx} value={f}>
                        <FlightTable scores={props.tournament.rounds
                            .filter(r => r.flight === f)
                            .sort(tournamentService.sortRounds)} />
                    </TabsPanel>)
                }
                {props.tournament.team &&
                    <TabsPanel key={'team'} value={'team'}>
                        <Box p='md'>
                            <Markdown className="remark" remarkPlugins={[remarkGfm]}>
                                {props.tournament.team}
                            </Markdown>
                        </Box>
                    </TabsPanel>
                }
            </Tabs>
        </Card>
    )
}

export default TournamentCard;